import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { electricRouteDefinitions } from './ElectricRouteDefinitions';

import { generatePageWithTabsRoute } from '../routeGenerator';

const IntervalDataElectricRoutes: RouteObject = generatePageWithTabsRoute(
  'Explore electric usage and demand data',
  BASE.INTERVAL_DATA_ELECTRIC,
  NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.USAGE,
  electricRouteDefinitions,
);

export default IntervalDataElectricRoutes;
